(function () {
  "use strict";

  var STRIP_COUNT = 9;
  var SPREAD_RATIO = 0.40;

  function makeH3Link(container) {
    if (!container) return;
    var h3 = container.querySelector("h3");
    if (!h3) return;
    if (h3.querySelector("a")) return;
    if (h3.parentNode && h3.parentNode.tagName.toLowerCase() === "a") return;

    var link = document.createElement("a");
    link.href = "/contact-us";
    link.className = "discuss-h3-link";
    while (h3.firstChild) {
      link.appendChild(h3.firstChild);
    }
    h3.appendChild(link);
  }

  function init() {
    var section = document.querySelector(".discuss-project-section");
    if (!section) return;

    var container = section.querySelector(".discuss-container");
    if (container) {
      makeH3Link(container);
    }

    var yesTextEl = section.querySelector(".yes-text span");
    var text = yesTextEl ? yesTextEl.textContent.trim() : "YESS SOLUTION";

    section.classList.add("is-animated");
    buildStructure(section, text);
  }

  function buildStructure(section, text) {
    var container = section.querySelector(".discuss-container");

    var sticky = document.createElement("div");
    sticky.className = "discuss-sticky";

    var ghost = document.createElement("div");
    ghost.className = "discuss-ghost";
    ghost.setAttribute("aria-hidden", "true");
    ghost.textContent = text;
    sticky.appendChild(ghost);

    var stripsWrap = document.createElement("div");
    stripsWrap.className = "discuss-strips";
    stripsWrap.setAttribute("aria-hidden", "true");

    var strips = [];
    var pct = 70 / STRIP_COUNT;

    for (var i = 0; i < STRIP_COUNT; i++) {
      var el = document.createElement("div");
      el.className = "discuss-strip";
      el.textContent = text;

      var topPct = (i * pct).toFixed(4);
      var botPct = (70 - (i + 1) * pct).toFixed(4);
      el.style.clipPath = "inset(" + topPct + "% 0 " + botPct + "% 0)";

      stripsWrap.appendChild(el);

      var norm = (i + 0.5 - STRIP_COUNT / 2) / (STRIP_COUNT / 2);
      var eased = Math.sign(norm) * Math.pow(Math.abs(norm), 1.3);
      strips.push({ el: el, dist: eased });
    }

    sticky.appendChild(stripsWrap);

    if (container) {
      container.parentNode.removeChild(container);
      sticky.appendChild(container);
    }

    section.appendChild(sticky);
    initScroll(section, strips, sticky);
  }

  function initScroll(section, strips, sticky) {
    var ticking = false;
    var maxScroll, maxSpread;

    function cacheLayout() {
      maxScroll = section.offsetHeight - sticky.offsetHeight;
      maxSpread = sticky.offsetHeight * SPREAD_RATIO;
    }

    function update() {
      var scrollInto = Math.max(
        0,
        Math.min(-section.getBoundingClientRect().top, maxScroll),
      );
      var progress = maxScroll > 0 ? scrollInto / maxScroll : 0;

      for (var i = 0; i < strips.length; i++) {
        var offset = strips[i].dist * progress * maxSpread;
        strips[i].el.style.transform =
          "translate(-50%, -50%) translateY(" + offset + "px)";
        strips[i].el.style.opacity = "1";
      }

      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }

    cacheLayout();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener(
      "resize",
      function () {
        cacheLayout();
        requestAnimationFrame(update);
      },
      { passive: true },
    );
    requestAnimationFrame(update);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      requestAnimationFrame(init);
    });
  } else {
    requestAnimationFrame(init);
  }
})();
